import React from 'react';


const About = () => {

    return (
        <div className="m-4">
            <h1 className="text-center display-4 mb-5">Arrow</h1>
            <p>Launched in 2016, Arrow was the first one-of-its kind large format specialist
                retail store that catered to all multi-brand digital gadgets and home electronic
                needs in India. Over a decade since its inception, today Arrow caters to over
                10 Million customers and has almost become synonymous for all electronics
                needs, with its tech-savvy staff, product range, online presence and the
                will to help customers
                </p>
            <p>
                Bringing alive the promise of a ‘Brighter Every Day’ for its customers,
                Arrow offers a world-class ambience to shop both in-store and online at
                 www.arrow.com, giving customers a seamless ‘omni-channel’ shopping experience
                that lets him/ her enjoy the best of both the online & the offline worlds.
                Arrow is also the first omni-channel electronics retailer uniting the varying
                 customer touch-points: a full-fledged Arrow Store and the Online Electronics
                 Shop, i.e. the website. By availing Arrow’s omni-channel services, a customer
                 can order their favourite electronics online and pick it up from the nearest
                 store or with its virtual aisle feature; can place an order of their dream
                 gadget not available at the store; but available on www.arrow.com and get it
                 delivered to their doorstep. Customers can also opt for the express shipping
                 feature which enables a customer to get a product delivered to their doorstep
                 within 3 hours.
                </p>

            <p>
                arrow ensures there is something for everyone with over 6000 products – Digital Gadgets
                like Mobile Phones, Laptops, Tablets or Entertainment Solutions like Televisions, Sound
                Bars & Home Theatres or Cameras & Accessories for photography enthusiasts or Home Appliances
                like Air Conditioners, Refrigerators, Washing Machines or Cooking & Kitchen Appliances like
                Air Fryers, Soup Makers, Cooktops, Dishwashers. With over 200 brands and 120+ stores across
                25+ major cities of India, arrow ensures that for each customer, a Brighter Tomorrow begins
                Today! From the newlywed couple setting up their house to the son reducing his mother’s burden
                with a washing machine; from the daughter gifting her parents a new LED TV to the newly promoted
                manager buying an inverter air-conditioner to make the summer bearable, arrow ensures that
                customers always get ‘More for their money’! arrow also brings arrow Privileges; its Gift Card
                solution that gives customers the freedom of choice, with Gift Cards and e-Gift Vouchers of
                multiple denominations.
            </p>
            <p>arrow also gives its customers multiple payment gateways so that they can choose to pay via their
                 preferred payment option. A customer could choose from any payment mode like credit or debit cards, payment wallets and cash-on-delivery. arrow also allows its customers to avail of various Easy EMI options on cards and through consumer finance. Additionally, to ensure that customers enjoy their product to the fullest, arrow encourages purchase of Extended Warranty,
                an insurance that safeguards their product against mishaps.</p>

            <p>In line with what arrow stands for, it also offers its customers an Assured Lifetime
                Service, an assurance of exceptional after sales service – which can be simply availed
                by walking into the nearest arrow store or calling up the 24x7 customer care centre at
                7207-666-777
              </p>
            <p>
                With this intent to delight customers all along, arrow launched its own label products in 2008.
                Brand arrow stands for – Life More Beautiful; the promise is based not just on the beauty in the
                way they look but also the value they offer to a customer’s life. The range is a perfect fit,
                for those who desire a completely feature-packed and quality product.
            </p>
        </div>
    )
}


export default About;